import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectPhasesTableOpenReducer(state = initialState.projectPhasesTableOpen, action) {

    const updatePhase = (phases, phase) => {  
        return phases.filter(ph => ph.id !== phase.id)
            .concat(phase);
    }

    const togglePhase = (phases, phaseId) => {
        const phase = phases.find(ph => ph.id === phaseId);
        if (phase === undefined) {
            return phases;
        }
        const newOpen = !phase.open;
        const updatedPhase = { ...phase, open: newOpen };
        return updatePhase(phases, updatedPhase);
    }

    switch (action.type) {        
        case types.UPDATE_PROJECT_PHASES_OPEN:
            return updatePhase(state, action.phase);
        case types.UPDATE_PROJECT_PHASES_OPEN_TOGGLE:
            return togglePhase(state, action.phase.id);
        default:
            return state;
    }
}